import React from 'react';
import { Users, UserCog, Mail, Settings, BarChart } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

interface Brand {
  id: string;
  name: string;
  organizationId: string;
  subdomain: string;
  settings?: any;
}

interface TopBarProps {
  selectedBrand: Brand | null;
}

export function TopBar({ selectedBrand }: TopBarProps) {
  const location = useLocation();

  const menuItems = [
    { icon: Users, label: 'Applicant Screening', path: '/' },
    { icon: UserCog, label: 'Creator Management', path: '/creators' },
    { icon: Mail, label: 'Email Templates', path: '/templates' },
    { icon: BarChart, label: 'Analytics', path: '/analytics' }
  ];

  const isSettingsActive = location.pathname.includes('/settings/organizations/');

  return (
    <div className="h-16 bg-gray-800 fixed top-0 left-0 right-0 flex items-end justify-between px-6 z-30">
      <div className="flex space-x-1">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex items-center space-x-3 px-6 py-3 rounded-t-lg transition-colors relative h-[48px]
              ${location.pathname === item.path 
                ? 'bg-gray-900 text-white before:absolute before:bottom-0 before:left-[-10px] before:w-[10px] before:h-[10px] before:bg-gray-800 before:rounded-br-lg after:absolute after:bottom-0 after:right-[-10px] after:w-[10px] after:h-[10px] after:bg-gray-800 after:rounded-bl-lg' 
                : 'text-gray-300 hover:bg-gray-700'}`}
          >
            <item.icon className="w-5 h-5" />
            <span className="font-medium">{item.label}</span>
          </Link>
        ))}
      </div>
      
      {selectedBrand && (
        <Link
          to={`/settings/organizations/${selectedBrand.organizationId}/gmail`}
          className={`flex items-center space-x-3 px-6 py-3 rounded-t-lg transition-colors relative h-[48px]
            ${isSettingsActive
              ? 'bg-gray-900 text-white before:absolute before:bottom-0 before:left-[-10px] before:w-[10px] before:h-[10px] before:bg-gray-800 before:rounded-br-lg after:absolute after:bottom-0 after:right-[-10px] after:w-[10px] after:h-[10px] after:bg-gray-800 after:rounded-bl-lg' 
              : 'text-gray-300 hover:bg-gray-700'}`}
          title="Settings"
        >
          <Settings className="w-5 h-5" />
          <span className="font-medium">Settings</span>
        </Link>
      )}
    </div>
  );
} 